/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DatalistAnagrafica, DocumentoProgetto } from '@models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ProgettoService } from '@shared/services/progetto.service';

@Component({
    selector: 'app-toolkit-modal-upload-documento',
    templateUrl: './modal-upload-documento.component.html',
})
export class ToolkitGestioneProgettoModalUploadDocumentoComponent implements OnInit {
    
    @Input() azione: string;
    @Input() datalist: DatalistAnagrafica;
    @Input() params: DocumentoProgetto;

    public file: any;
    public criteriaForm: FormGroup;

    constructor(
        public activeModal: NgbActiveModal,
        private progettoService: ProgettoService,
        private fb: FormBuilder
    ) { }

    ngOnInit() {
        this.criteriaForm = this.fb.group({
            idClasseDocumento: this.fb.control(null, Validators.required),
            idDocumento: this.fb.control(null),
            idProgetto: this.fb.control(this.progettoService.progettoSession.idProgetto, Validators.required),
            didascalia: this.fb.control(null, Validators.required),
            docPublic: this.fb.control(1, Validators.required)
        });
        if (this.params) {
            this.file = 'file';
            this.criteriaForm.patchValue(this.params);
        }
    }

    public save() {
        this.activeModal.close({
            form: this.criteriaForm,
            file: this.file,
        });
    }

    public setFile(file: any) {
        this.file = file;
    }

}
